<template>
  <div class="row page-content-wrapper">
    <div class="col-12">
      <page-header>
        <template v-slot:action-buttons>
          <b-button
            v-if="isEditor"
            variant="outline-primary"
            size="sm"
            @click="deleteOrder"
          >
            {{ 'delete' | i18n }}
          </b-button>
          <b-button
            v-if="isEditor"
            variant="primary"
            :disabled="isEditMode"
            size="sm"
            @click="editOrder"
          >
            {{ 'edit' | i18n }}
          </b-button>
          <b-dropdown
            v-if="order"
            variant="outline-primary"
            right
            class="actions-dropdown"
            size="sm"
          >
            <b-dropdown-item
              :href="appConfig.apiUrl + '/Auftragsverarbeitung/Print/' + order.id"
              target="_blank"
            >
              {{ 'print_without_image' | i18n }}
            </b-dropdown-item>
            <b-dropdown-item
              :href="appConfig.apiUrl + '/Auftragsverarbeitung/PrintWithPictures/' + order.id"
              target="_blank"
            >
              {{ 'print_with_image' | i18n }}
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </page-header>
      <div class="row page-section">
        <div class="col-12 main-content">
          <div
            v-if="order"
            class="row"
          >
            <div class="col-12">
              <order-info
                v-if="!isEditMode"
                :order="order"
              />
              <edit-order
                v-if="isEditMode"
                :order="order"
                @cancel="isEditMode = false"
                @saved="onSaved"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Order positions section -->
      <order-positions
        v-if="order"
        :order-id="order.id"
        :can-edit="isEditor"
      />
      <!--/ Order positions section END -->
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import {OrderMixin, NavigationMixin, NotificationMixin, AuthMixin, DeleteRowMixin} from '../../mixins/index';
import OrderPositions from './order-positions';
import OrderInfo from './order-info';
import EditOrder from './edit-order';
import appConfig from '../../app.config';
import PageHeader from '../structure/page-header';

export default {
  name: 'OrderDetails',
  components: {PageHeader, EditOrder, OrderInfo, OrderPositions},
  mixins: [OrderMixin, NavigationMixin, NotificationMixin, AuthMixin, DeleteRowMixin],
  data: function () {
    return {
      order: null,
      isEditMode: false,
      appConfig
    };
  },
  computed: {
    ...mapState({
      selectedOrder: state => state.order.selectedOrder
    })
  },
  created() {
    if (this.selectedOrder) {
      this.order = {...this.selectedOrder};
    } else {
      this.loadOrder(this.$route.params.id);
    }

    this.isEditMode = this.isEditor;
  },
  methods: {
    ...mapActions({setSelectedOrder: 'order/setSelectedOrder'}),
    async loadOrder(id) {
      try {
        const response = await this.orderService.getOrderById(id);
        this.order = {
          ...response.order,
          createdDate: response.order.createdDate,
          dateOfDelivery: response.order.dateOfDelivery
        };
      } catch (err) {
        this.showNotification({type: 'error', message: err.message});
      }
    },
    async deleteOrder() {
      await this.deleteSelectedRows({
        message: this.$translate('order_delete_confirmation_message'),
        rowDisplayValues: []
      }, async () => {
        await this.orderService.deleteOrder(this.order.id);
        await this.goBack();
      });
    },
    editOrder() {
      this.isEditMode = true;
    },
    onSaved() {
      this.isEditMode = false;
      this.loadOrder(this.$route.params.id);
    }
  }
};
</script>

<style scoped lang="scss">
  ::v-deep   .action-buttons .dropdown-toggle {
    margin-right: 0;
  }
</style>
